import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { rankingComunidade, niveisGamificacao, recompensasGamificacao } from '../../../mocks/comunidade';

const RankingComunidade = () => {
  const [activeTab, setActiveTab] = useState<'ranking' | 'niveis' | 'recompensas'>('ranking');
  const navigate = useNavigate();

  const getMedalColor = (posicao: number) => {
    if (posicao === 1) return 'from-yellow-400 to-amber-500';
    if (posicao === 2) return 'from-gray-300 to-gray-400';
    if (posicao === 3) return 'from-amber-600 to-amber-700';
    return '';
  };

  const getMedalIcon = (posicao: number) => {
    if (posicao <= 3) return 'ri-trophy-fill';
    return '';
  };

  return (
    <section className="bg-luxury-black py-28 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute top-32 left-16 w-80 h-80 bg-gold-500/[0.03] rounded-full blur-[140px]"></div>
      <div className="absolute bottom-32 right-16 w-64 h-64 bg-gold-500/[0.03] rounded-full blur-[120px]"></div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        {/* Header */}
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="w-12 h-px bg-gold-500/40"></div>
          <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
            Gamificação
          </span>
          <div className="w-12 h-px bg-gold-500/40"></div>
        </div>

        <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-center text-white mb-4">
          Ranking dos <span className="italic text-gold-400">Transformadores</span>
        </h2>
        <p className="font-['Montserrat'] text-sm text-white/35 text-center max-w-lg mx-auto mb-14 font-light tracking-wide">
          Quanto mais você convida, mais alto sobe. Desbloqueie recompensas exclusivas e conquiste seu lugar no topo.
        </p>

        {/* Tabs */}
        <div className="flex items-center justify-center mb-12">
          <div className="bg-white/[0.04] border border-gold-500/10 rounded-full p-1 flex gap-1">
            <button
              onClick={() => setActiveTab('ranking')}
              className={`font-['Montserrat'] text-xs tracking-wider uppercase px-6 py-2.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'ranking'
                  ? 'bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-semibold'
                  : 'text-white/40 hover:text-white/60'
              }`}
            >
              <span className="flex items-center gap-2">
                <i className="ri-trophy-fill text-sm"></i>
                Ranking
              </span>
            </button>
            <button
              onClick={() => setActiveTab('niveis')}
              className={`font-['Montserrat'] text-xs tracking-wider uppercase px-6 py-2.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'niveis'
                  ? 'bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-semibold'
                  : 'text-white/40 hover:text-white/60'
              }`}
            >
              <span className="flex items-center gap-2">
                <i className="ri-bar-chart-fill text-sm"></i>
                Níveis
              </span>
            </button>
            <button
              onClick={() => setActiveTab('recompensas')}
              className={`font-['Montserrat'] text-xs tracking-wider uppercase px-6 py-2.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'recompensas'
                  ? 'bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-semibold'
                  : 'text-white/40 hover:text-white/60'
              }`}
            >
              <span className="flex items-center gap-2">
                <i className="ri-gift-fill text-sm"></i>
                Recompensas
              </span>
            </button>
          </div>
        </div>

        {/* Tab: Ranking */}
        {activeTab === 'ranking' && (
          <div className="max-w-4xl mx-auto">
            {/* Top 3 Podium */}
            <div className="grid grid-cols-3 gap-4 mb-10">
              {/* 2nd Place */}
              <div className="flex flex-col items-center pt-8">
                <div
                  className="relative mb-4 cursor-pointer group"
                  onClick={() => navigate(`/membro/${rankingComunidade[1].id}`)}
                >
                  <div className="w-20 h-20 rounded-full overflow-hidden border-[3px] border-gray-400/40 shadow-lg group-hover:border-gold-500/50 transition-all duration-300">
                    <img
                      src={rankingComunidade[1].avatar}
                      alt={rankingComunidade[1].nome}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className={`absolute -bottom-2 -right-1 w-8 h-8 rounded-full bg-gradient-to-br ${getMedalColor(2)} flex items-center justify-center shadow-md`}>
                    <i className={`${getMedalIcon(2)} text-white text-xs`}></i>
                  </div>
                </div>
                <h4
                  onClick={() => navigate(`/membro/${rankingComunidade[1].id}`)}
                  className="font-['Playfair_Display'] text-sm font-semibold text-white text-center mb-0.5 cursor-pointer hover:text-gold-400 transition-colors duration-300"
                >
                  {rankingComunidade[1].nome}
                </h4>
                <p className="font-['Montserrat'] text-[10px] text-white/30 mb-2">{rankingComunidade[1].cidade}</p>
                <div className="bg-white/[0.06] border border-gray-400/15 rounded-lg px-4 py-2 text-center">
                  <p className="font-['Playfair_Display'] text-xl font-bold text-gray-300">{rankingComunidade[1].convites}</p>
                  <p className="font-['Montserrat'] text-[9px] text-white/25 uppercase tracking-wider">convites</p>
                </div>
                <div className="mt-3 bg-gray-400/10 rounded-full px-3 py-1">
                  <span className="font-['Montserrat'] text-[10px] text-gray-400 font-medium">{rankingComunidade[1].nivel}</span>
                </div>
              </div>

              {/* 1st Place */}
              <div className="flex flex-col items-center">
                <div
                  className="relative mb-4 cursor-pointer group"
                  onClick={() => navigate(`/membro/${rankingComunidade[0].id}`)}
                >
                  <div className="w-24 h-24 rounded-full overflow-hidden border-[3px] border-gold-500/50 shadow-[0_0_30px_rgba(201,168,76,0.2)] group-hover:shadow-[0_0_40px_rgba(201,168,76,0.35)] transition-all duration-300">
                    <img
                      src={rankingComunidade[0].avatar}
                      alt={rankingComunidade[0].nome}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className={`absolute -bottom-2 -right-1 w-9 h-9 rounded-full bg-gradient-to-br ${getMedalColor(1)} flex items-center justify-center shadow-lg shadow-amber-500/30`}>
                    <i className={`${getMedalIcon(1)} text-white text-sm`}></i>
                  </div>
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <i className="ri-vip-crown-2-fill text-gold-400 text-2xl drop-shadow-lg"></i>
                  </div>
                </div>
                <h4
                  onClick={() => navigate(`/membro/${rankingComunidade[0].id}`)}
                  className="font-['Playfair_Display'] text-base font-semibold text-white text-center mb-0.5 cursor-pointer hover:text-gold-400 transition-colors duration-300"
                >
                  {rankingComunidade[0].nome}
                </h4>
                <p className="font-['Montserrat'] text-[10px] text-white/30 mb-2">{rankingComunidade[0].cidade}</p>
                <div className="bg-gold-500/[0.08] border border-gold-500/20 rounded-lg px-5 py-2.5 text-center">
                  <p className="font-['Playfair_Display'] text-2xl font-bold text-gold-400">{rankingComunidade[0].convites}</p>
                  <p className="font-['Montserrat'] text-[9px] text-gold-500/50 uppercase tracking-wider">convites</p>
                </div>
                <div className="mt-3 bg-gold-500/10 rounded-full px-3 py-1">
                  <span className="font-['Montserrat'] text-[10px] text-gold-400 font-medium">{rankingComunidade[0].nivel}</span>
                </div>
              </div>

              {/* 3rd Place */}
              <div className="flex flex-col items-center pt-12">
                <div
                  className="relative mb-4 cursor-pointer group"
                  onClick={() => navigate(`/membro/${rankingComunidade[2].id}`)}
                >
                  <div className="w-18 h-18 rounded-full overflow-hidden border-[3px] border-amber-700/30 shadow-lg group-hover:border-gold-500/50 transition-all duration-300" style={{ width: '72px', height: '72px' }}>
                    <img
                      src={rankingComunidade[2].avatar}
                      alt={rankingComunidade[2].nome}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className={`absolute -bottom-2 -right-1 w-7 h-7 rounded-full bg-gradient-to-br ${getMedalColor(3)} flex items-center justify-center shadow-md`}>
                    <i className={`${getMedalIcon(3)} text-white text-[10px]`}></i>
                  </div>
                </div>
                <h4
                  onClick={() => navigate(`/membro/${rankingComunidade[2].id}`)}
                  className="font-['Playfair_Display'] text-sm font-semibold text-white text-center mb-0.5 cursor-pointer hover:text-gold-400 transition-colors duration-300"
                >
                  {rankingComunidade[2].nome}
                </h4>
                <p className="font-['Montserrat'] text-[10px] text-white/30 mb-2">{rankingComunidade[2].cidade}</p>
                <div className="bg-white/[0.06] border border-amber-700/15 rounded-lg px-4 py-2 text-center">
                  <p className="font-['Playfair_Display'] text-xl font-bold text-amber-600">{rankingComunidade[2].convites}</p>
                  <p className="font-['Montserrat'] text-[9px] text-white/25 uppercase tracking-wider">convites</p>
                </div>
                <div className="mt-3 bg-amber-700/10 rounded-full px-3 py-1">
                  <span className="font-['Montserrat'] text-[10px] text-amber-600 font-medium">{rankingComunidade[2].nivel}</span>
                </div>
              </div>
            </div>

            {/* Rest of ranking list */}
            <div className="bg-white/[0.03] border border-gold-500/10 rounded-2xl overflow-hidden">
              {rankingComunidade.slice(3).map((user, index) => (
                <div
                  key={user.id}
                  onClick={() => navigate(`/membro/${user.id}`)}
                  className={`flex items-center gap-4 px-6 py-4 hover:bg-white/[0.06] transition-colors duration-300 cursor-pointer ${
                    index < rankingComunidade.slice(3).length - 1 ? 'border-b border-white/[0.04]' : ''
                  }`}
                >
                  <span className="font-['Montserrat'] text-sm font-bold text-white/20 w-8 text-center">
                    {user.posicao}
                  </span>
                  <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white/10 flex-shrink-0">
                    <img src={user.avatar} alt={user.nome} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-['Playfair_Display'] text-sm font-semibold text-white truncate hover:text-gold-400 transition-colors duration-300">
                      {user.nome}
                    </h4>
                    <p className="font-['Montserrat'] text-[10px] text-white/25">{user.cidade}</p>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <i className={`${user.badge} text-gold-500/60 text-xs`}></i>
                    <span className="font-['Montserrat'] text-[10px] text-white/35 hidden sm:block">{user.nivel}</span>
                  </div>
                  <div className="text-right min-w-[70px]">
                    <p className="font-['Montserrat'] text-sm font-bold text-gold-400">{user.convites}</p>
                    <p className="font-['Montserrat'] text-[9px] text-white/20">convites</p>
                  </div>
                  <div className="text-right min-w-[60px] hidden sm:block">
                    <p className="font-['Montserrat'] text-sm font-semibold text-white/50">{user.cartasCriadas}</p>
                    <p className="font-['Montserrat'] text-[9px] text-white/20">cartas</p>
                  </div>
                  <i className="ri-arrow-right-s-line text-white/15 text-lg"></i>
                </div>
              ))}
            </div>

            {/* Your position CTA */}
            <div className="mt-8 bg-gradient-to-r from-gold-500/[0.06] to-gold-600/[0.06] border border-gold-500/15 rounded-2xl p-6 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gold-500/10 border border-gold-500/20 flex items-center justify-center">
                  <i className="ri-user-star-fill text-gold-500 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-['Playfair_Display'] text-base font-semibold text-white mb-0.5">
                    Sua posição: <span className="text-gold-400">Fora do ranking</span>
                  </h4>
                  <p className="font-['Montserrat'] text-xs text-white/35 font-light">
                    Convide amigos para subir no ranking e desbloquear recompensas
                  </p>
                </div>
              </div>
              <a
                href="#convite-section"
                className="bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-xs px-6 py-3 rounded-lg hover:shadow-[0_0_20px_rgba(201,168,76,0.25)] transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider uppercase flex items-center gap-2"
              >
                <i className="ri-share-forward-fill text-sm"></i>
                Convidar
              </a>
            </div>
          </div>
        )}

        {/* Tab: Níveis */}
        {activeTab === 'niveis' && (
          <div className="max-w-3xl mx-auto">
            <div className="space-y-4">
              {niveisGamificacao.map((nivel, index) => (
                <div
                  key={nivel.nivel}
                  className="bg-white/[0.03] border border-gold-500/10 rounded-2xl p-6 hover:border-gold-500/20 transition-all duration-500 group"
                >
                  <div className="flex items-center gap-5">
                    <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${nivel.cor} flex items-center justify-center shadow-lg flex-shrink-0 group-hover:scale-110 transition-transform duration-500`}>
                      <i className={`${nivel.icon} text-white text-2xl`}></i>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-1">
                        <h4 className="font-['Playfair_Display'] text-lg font-semibold text-white">
                          {nivel.nivel}
                        </h4>
                        <span className={`font-['Montserrat'] text-[10px] ${nivel.corTexto} ${nivel.corBg} px-2.5 py-0.5 rounded-full tracking-wider uppercase font-medium`}>
                          Nível {index + 1}
                        </span>
                      </div>
                      <p className="font-['Montserrat'] text-xs text-white/35 font-light mb-3">
                        {nivel.descricao}
                      </p>
                      <div className="flex items-center gap-2">
                        <div className="flex-1 h-1.5 bg-white/[0.06] rounded-full overflow-hidden">
                          <div
                            className={`h-full bg-gradient-to-r ${nivel.cor} rounded-full transition-all duration-700`}
                            style={{ width: `${((index + 1) / niveisGamificacao.length) * 100}%` }}
                          ></div>
                        </div>
                        <span className="font-['Montserrat'] text-[10px] text-white/30 whitespace-nowrap">
                          {nivel.minConvites === 0 ? '0' : nivel.minConvites}
                          {nivel.maxConvites < 999 ? ` — ${nivel.maxConvites}` : '+'} convites
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 text-center">
              <p className="font-['Montserrat'] text-xs text-white/25 font-light tracking-wide mb-6">
                Suba de nível convidando mais amigos para a comunidade
              </p>
              <a
                href="#convite-section"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-xs px-8 py-3.5 rounded-lg hover:shadow-[0_0_20px_rgba(201,168,76,0.25)] transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider uppercase"
              >
                <i className="ri-rocket-fill text-sm"></i>
                Começar a Convidar
              </a>
            </div>
          </div>
        )}

        {/* Tab: Recompensas */}
        {activeTab === 'recompensas' && (
          <div className="max-w-3xl mx-auto">
            <div className="relative">
              {/* Vertical line */}
              <div className="absolute left-7 top-0 bottom-0 w-px bg-gradient-to-b from-gold-500/30 via-gold-500/10 to-transparent"></div>

              <div className="space-y-6">
                {recompensasGamificacao.map((recompensa, index) => (
                  <div key={index} className="flex items-start gap-6 relative">
                    {/* Node */}
                    <div className={`w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0 relative z-10 transition-all duration-500 ${
                      recompensa.conquistado
                        ? 'bg-gradient-to-br from-gold-500 to-gold-600 shadow-[0_0_20px_rgba(201,168,76,0.3)]'
                        : 'bg-white/[0.06] border border-white/10'
                    }`}>
                      <i className={`${recompensa.icon} text-xl ${
                        recompensa.conquistado ? 'text-luxury-black' : 'text-white/25'
                      }`}></i>
                    </div>

                    {/* Content */}
                    <div className={`flex-1 rounded-2xl p-6 transition-all duration-500 ${
                      recompensa.conquistado
                        ? 'bg-gold-500/[0.06] border border-gold-500/20'
                        : 'bg-white/[0.03] border border-white/[0.06]'
                    }`}>
                      <div className="flex items-center justify-between mb-2">
                        <h4 className={`font-['Playfair_Display'] text-base font-semibold ${
                          recompensa.conquistado ? 'text-gold-400' : 'text-white/50'
                        }`}>
                          {recompensa.titulo}
                        </h4>
                        {recompensa.conquistado ? (
                          <span className="flex items-center gap-1.5 bg-emerald-500/10 text-emerald-400 font-['Montserrat'] text-[10px] px-3 py-1 rounded-full tracking-wider uppercase font-medium">
                            <i className="ri-check-double-line text-xs"></i>
                            Conquistado
                          </span>
                        ) : (
                          <span className="flex items-center gap-1.5 bg-white/[0.04] text-white/30 font-['Montserrat'] text-[10px] px-3 py-1 rounded-full tracking-wider uppercase">
                            <i className="ri-lock-line text-xs"></i>
                            Bloqueado
                          </span>
                        )}
                      </div>
                      <p className={`font-['Montserrat'] text-xs font-light mb-3 ${
                        recompensa.conquistado ? 'text-white/45' : 'text-white/25'
                      }`}>
                        {recompensa.descricao}
                      </p>
                      <div className="flex items-center gap-2">
                        <i className={`ri-user-add-fill text-xs ${recompensa.conquistado ? 'text-gold-500/50' : 'text-white/15'}`}></i>
                        <span className={`font-['Montserrat'] text-[10px] tracking-wider ${
                          recompensa.conquistado ? 'text-gold-500/50' : 'text-white/20'
                        }`}>
                          {recompensa.convitesNecessarios} convites necessários
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-10 text-center">
              <p className="font-['Montserrat'] text-xs text-white/25 font-light tracking-wide mb-6">
                Desbloqueie todas as recompensas convidando amigos
              </p>
              <a
                href="#convite-section"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-xs px-8 py-3.5 rounded-lg hover:shadow-[0_0_20px_rgba(201,168,76,0.25)] transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider uppercase"
              >
                <i className="ri-gift-fill text-sm"></i>
                Desbloquear Recompensas
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default RankingComunidade;
